import { Device, getDeviceSize } from 'DeviceUtils';
import createOnboardingItem from 'Pages/Onboarding/createOnboardingItem';
import { t } from 'Locale/index';
import { localeToLanguage } from '@24i/st-api-connector/utils';
import { DEFAULT_LANGUAGE } from 'Options';

// This is negotiated format that EN screen is ALWAYS secondary screen
const SECONDARY_SCREEN_ITEM_LANG = 'EN';

export const screenTypes = Object.freeze({
    phonePortrait: 'phonePortrait',
    phoneLandscape: 'phoneLandscape',
    tabletPortrait: 'tabletPortrait',
    tabletLandscape: 'tabletLandscape'
});

const getBestDimensions = (deviceSize, assets) => {
    let bestSize;
    assets.forEach((asset) => {
        if (deviceSize.width <= asset.size.width && deviceSize.height <= asset.size.height) {
            bestSize = asset;
        }
    });
    return bestSize;
};

export const getScreenTypeByDeviceType = () => {
    if (Device.platformString === 'phone') return screenTypes.phonePortrait;
    // Tablet is always landscape
    return screenTypes.tabletLandscape;
};

export const getImageUrlsFromAssets = (
    assets,
    screenType,
    size = { width: 1080, height: 1920 }
) => {
    if (!assets[screenType])
        throw new Error(`Screen type ${screenType} is not present or supported in assets`);
    return assets[screenType]
        .map((imageObj) => {
            const match = getBestDimensions(size, imageObj.src);

            return match?.url || null;
        })
        .filter((asset) => asset !== null);
};

export const getCustomOnboardingItems = async (api, featuress, lang) => {
    if (!api) throw new Error('api must be provided');
    const features = undefined;
    if (
        features?.welcomeScreens?.enabled &&
        features?.welcomeScreens?.screens &&
        features?.welcomeScreens?.screens?.length > 0
    ) {
        try {
            const { screens } = features.welcomeScreens;
            if (screens.length === 0) return [];

            let fetchedWelcomeScreen;

            // This is negotiated format that EN screen is ALWAYS secondary screen
            if (lang === SECONDARY_SCREEN_ITEM_LANG && screens.length > 1) {
                fetchedWelcomeScreen = await api.fetchWelcomeScreen(screens[1].welcomeScreenId);
            } else {
                const screenVariations = await Promise.all(
                    screens
                        .map((screen) => api.fetchWelcomeScreen(screen.welcomeScreenId))
                        .filter(Boolean)
                );
                // Find screen with app localization
                fetchedWelcomeScreen = screenVariations.find((screen) => screen.name === lang);
                // If no localized screen is found return screen with the default lang
                if (!fetchedWelcomeScreen) {
                    fetchedWelcomeScreen = screenVariations.find(
                        (screen) => screen.name === localeToLanguage(DEFAULT_LANGUAGE)
                    );
                }
            }

            if (!fetchedWelcomeScreen) return [];

            const urls = getImageUrlsFromAssets(
                fetchedWelcomeScreen.assets,
                getScreenTypeByDeviceType(),
                getDeviceSize()
            );

            // Reformat output to common onboarding item object
            return urls.map((uri, index) =>
                // Insert button title on last item
                createOnboardingItem(
                    { uri },
                    t(`COMMON.ONBOARDING_TEXT${index + 1}`),
                    index + 1 === urls.length ? t('COMMON.ONBOARDING_BTN_EXPLORE') : ''
                )
            );
        } catch (error) {
            console.log('Failed to get custom welcome screens');
            console.log(error);
        }
    }

    return [];
};
